export default __webpack_public_path__ + "static/6_16-11003aaa264efd46ed0be994a46bde20.png";